import React, { useEffect } from 'react';
import { createStyles } from 'antd-style';
import { useAppDispatch } from 'store/hook';
import { PAGE_UPDATE, PAGE_INIT } from 'store/pageReducer';
import { LoadWrap } from 'ui-component/motion/load';

export const useStyles = createStyles(({ token, css }, { fill }: { fill: boolean }) => {
  return {
    container: fill
      ? css`
          height: 100%;
          overflow: hidden;
        `
      : ''
  };
});

interface IHookProps {
  title?: any;
  children: React.ReactElement;
  noMotion?: boolean;
  contentFill?: boolean;
  [propName: string]: any;
}

const CMP: React.FC<IHookProps> = ({ children, title, noMotion, contentFill, ...props }) => {
  const dispatch = useAppDispatch();
  const { styles, cx } = useStyles({ fill: !!contentFill });

  useEffect(() => {
    dispatch(
      PAGE_UPDATE({
        title: title || ''
      })
    );

    return () => {
      dispatch(PAGE_INIT());
    };
  }, [title]);

  if (noMotion) return <>{children}</>;
  return (
    <LoadWrap className={cx(styles.container, props.className)} {...props}>
      {children}
    </LoadWrap>
  );
};

export default CMP;
